





















import Vue from 'vue';
import Component from 'vue-class-component';
import {IDENTITY_SERVICE_INSTANCE} from '@/services/identity.service';
import {ROUTER_SERVICE} from '@/services/router.service';
import {USER_SERVICE_INSTANCE} from '@/services/user.service';
import {forkJoin, from, map} from 'rxjs';
import {NAVI_SERVICE_INSTANCE} from '@/services/navi.service';
import {DisguiseBusinessExceptionWrapper} from '@/exception/disguise-business-exception-wrapper';
import store from '@/store';

@Component({})
export default class TokenLoginTemplate extends Vue {
  showDialog = true;

  created() {
    let token = '';
    if (!Array.isArray(this.$route.query.token)) {
      token = this.$route.query.token;
    }
    IDENTITY_SERVICE_INSTANCE.createSessionUsingToken(token).then(() => {
      NAVI_SERVICE_INSTANCE.clearNaviCache();
      ROUTER_SERVICE.resetProtectedRoutes();
      // prefetch the user details, so that the user details are directly preloaded.

      forkJoin([
        NAVI_SERVICE_INSTANCE.loadNaviCached(),
        from(USER_SERVICE_INSTANCE.loadUserDetails()).pipe(map((res) => {
          return res.data;
        }))
      ]).subscribe({
        next: (value: [DisguiseDto.NaviEntryListDto, DisguiseDto.UserDataDto]) => {
          // set the user info to the vuex store
          this.$store.commit('setUserInfo', {userInfo: value[1]});

          let redirectToParam: string = '';
          if (!Array.isArray(this.$route.query.redirectTo)) {
            redirectToParam = this.$route.query.redirectTo;
          }
          if (!redirectToParam) {
            redirectToParam = '/welcome';
          } else if (redirectToParam.indexOf('/') !== 0) {
            redirectToParam = '/' + redirectToParam;
          }
          store.commit('setHideNavi', redirectToParam.indexOf('hideNavigation=true') >= 0);
          this.$router.push(redirectToParam);
        },
        error: (error) => {
          if (!(error instanceof DisguiseBusinessExceptionWrapper)) {
            this.$store.commit('showSnack', {
              message: 'Fehler beim Laden der Nutzerinformationen',
              color: 'error'
            });
          }
        }
      });
    }, (error) => {
      let statusMessage;
      let forwardingUrl;
      switch (error.response.status) {
        case 503:
          statusMessage = 'Identity Service ist nicht erreichbar';
          break;
        default:
          statusMessage = 'Ungültiges Token';
          forwardingUrl = window.location.origin + '/login';
          break;
      }
      alert(statusMessage);
      if (forwardingUrl) {
        window.location.href = forwardingUrl;
      }
    });
  }
}
